<template>
  <b-container>
    <b-row class="agenda-info-heading" v-if="event.description">
      <b-col>
        <div>
          <p class="single-info-nested-text" v-html="event.description"></p>
        </div>
        <a
          href="mailto:info@carriercommunity.com?subject=Support&cc=Kara@carriercommunity.com"
        >
          <button class="contact-btn mb-2">Contact us</button>
        </a>
      </b-col>
    </b-row>
    <b-row class="agenda-info-heading mb-3" v-if="reasons.length">
      <b-col class="mb-4 p-1">
        <h5 class="agenda-info-reasons-heading">Reasons to Attend</h5>
        <div class="agenda-info-reasons-images">
          <div
            class="agenda-info-res-text"
            v-for="reason in reasons"
            :key="reason.id"
            :style="`background-image: url(${reason.image})`"
          >
            <p class="reason-title">{{ reason.title }}</p>
            <p class="reason-text">{{ reason.text }}</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="agenda-info-strategic-slide mb-3" v-if="sponsors.length">
      <b-col class="mb-4">
        <h5 class="agenda-info-reasons-heading">
          Strategic co-hosted sponsors
        </h5>
        <div class="agenda-info-vueper-slides">
          <vueper-slides
            class="no-shadow"
            :visible-slides="3"
            slide-multiple
            :slide-ratio="1 / 4"
            :bullets="false"
            :gap="5"
          >
            <vueper-slide
              v-for="({ details }, i) in sponsors"
              :key="i"
              :image="details.logo"
              :style="'margin:0 10px'"
            />
          </vueper-slides>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="session.length">
      <b-col>
        <b-row class="agenda-info-knowledge-heading">
          <b-col>
            <h5 class="agenda-info-reasons-heading">
              Knowledge sharing sessions
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col id="agenda-info-knowledge-sessions-container">
            <div v-for="s in session" :key="s.id" class="mb-4">
              <img class="agenda-info-knowledge-img" :src="s.icon" alt="" />
              <button class="agenda-info-session-btn" @click="goToAgenda">See in agenda</button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="agenda-info-strategic mb-3 mt-3" v-if="parallelEvents.length">
      <b-col>
        <h5 class="agenda-info-reasons-heading">Parallel events</h5>
        <div>
          <div v-for="parallelEvent in parallelEvents" :key="parallelEvent.id">
            <b-row class="mb-4">
              <b-col cols="4">
                <img
                  class="agenda-info-parallel-img"
                  :src="parallelEvent.details.banner"
                  alt=""
                />
              </b-col>
              <b-col cols="7">
                <p
                  v-html="parallelEvent.description || parallelEvent.description_text"
                  class="agenda-info-parallel-p"
                ></p>
                <router-link
                  :to="{
                    name: 'standardEvent',
                    params: { eventId: getURL(parallelEvent.parallel_event) },
                  }"
                >
                  <button class="agenda-info-parallel-btn">learn more</button>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import InfoBeforeEvent from '../../../utils/mixins/InfoBeforeEvent';

export default {
  components: {
    VueperSlides,
    VueperSlide,
  },
  mixins: [InfoBeforeEvent],
};
</script>

<style scoped>
.agenda-info-res-text:hover .reason-text{
  display: block;
  cursor: pointer;
  text-align: center;
}
.agenda-info-res-text:hover .reason-title{
  display: none;
}

.reason-text{
  width: 100%;
  height: 80%;
  display: none;
  background: #55555591;
  color: white;
  font-size: 13px;
}
.reason-title{
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  background: #55555591;
  color: white;
  font-size: 13px;
}
.agenda-info-heading {
  background-color: #ffffff;
  border-radius: 0 10px 10px 10px;
}
.agenda-info-reasons-heading {
  padding: 6px 1px 19px 1px;
  border-bottom: 1.4px solid #ebebeb;
  text-align: center;
  text-transform: uppercase;
  font-family: Montserrat;
  margin-top: 8px;
}
.single-info-nested-text {
  text-align: center;
  font-size: 13px;
  color: #333333;
  padding: 20px 15px 1px 15px;
  word-wrap: break-word;
}
.single-info-nested-text > p {
  font-size: 13px;
  text-transform: initial;
}
.contact-btn {
  border: unset;
  margin: 16px 1px 1px 23px;
  border-radius: 0 10px 10px 10px;
  background: #bd9d5f;
  color: white;
  padding: 2px 6px;
  font-size: 12px;
}
.right-photo {
  margin-top: -35px;
}
.activites > img {
  width: 140px;
  border-right: 1px solid #d6d6d6;
  padding: 11px 2px 3px 11px;
}
.agenda-info-reasons-images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4px;
  object-fit: scale-down;
}
.kownledge-heading {
  background-color: white;
}
.agenda-info-knowledge-img {
  width: 90px;
  height: 75px;
  -o-object-fit: contain;
  object-fit: scale-down;
}
.agenda-info-session-btn {
  width: 92px;
  height: 20px;
  font-size: 10px;
  background: #bd9d5f;
  color: white;
  border: unset;
  border-radius: 0 10px 10px 10px;
  margin-left: -1px;
}
.agenda-info-session-btn-second {
  width: 92px;
  height: 20px;
  font-size: 10px;
  background: #ffffff;
  color: #bd9d5f;
  border: 1px solid;
  margin-left: -1px;
}
.agenda-info-res-text {
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.agenda-info-strategic,
.agenda-info-strategic-slide,
.agenda-info-knowledge-heading {
  background-color: #ffffff;
  border-radius: 0 10px 0 0;
}
#agenda-info-knowledge-sessions-container {
  background-color: #ffffff;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-row-gap: 17px;
  border-radius: 0 0 10px 10px;
}
.agenda-info-parallel-img {
  vertical-align: middle;
  border-style: none;
  width: 142px;
  border: 1px solid #e1dfdf;
  margin: 15px 0px 0px 20px;
  width: 80px;
  height: 80px;
  object-fit: scale-down;
}
.agenda-info-parallel-btn {
  float: right;
  background: white;
  border: 1px solid #bd9d5f;
  border-radius: 0 10px 10px 10px;
  color: #bd9d5f;
  font-size: 12px;
  padding: 3px 10px;
}
.agenda-info-parallel-p {
  color: #514f4f;
  font-size: 13px;
  margin-top: 19px;
}
</style>
<style>
.agenda-info-vueper-slides .vueperslide {
  background-size: contain;
  background-repeat: no-repeat;
}
.agenda-info-vueper-slides .vueperslides__bullets {
  display: none !important;
}
.agenda-info-vueper-slides
  .vueperslides__arrows--outside
  .vueperslides__arrow--prev {
  left: 0em;
  outline: none;
  top: 48px;
  font-size: 11px;
}
.agenda-info-vueper-slides
  .vueperslides__arrows--outside
  .vueperslides__arrow--next {
  right: -0em;
  outline: none;
  top: 52px;
  font-size: 11px;
}
</style>
<style>
.single-info-nested-text img {
  max-width: 565px;
  max-height: 300px;
  object-fit: cover;
}
.single-info-nested-text iframe {
  width: 565px;
  height: 300px;
  object-fit: cover;
}
</style>
